class DiscountCodeManager {
  constructor() {
    this.errors = [];
    this.message = new MeowcartLoyaltyMessage();
    this.staging = "https://" + Shopify.shop;
    this.provider = {
      hostName: meowcart.api_url,
    };
    this.apiEndPoint = {
      getMyCoupons: meowcart.endpoints.mdw.getCoupons,
      getCouponDetail: "/account/my-coupons/detail",
      discountUpdate: meowcart.endpoints.shopify.updateDiscount,
      synchronizeCoupons: meowcart.endpoints.mdw.syncCoupons,
    };

    const mainCartElement = document.querySelector(".main-cart-custom");
    const userToken = mainCartElement?.getAttribute("data-x-user-token") || "";

    this.loadingSpinner = new LoadingSpinner();
    this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    this.config = {
      currentPage: 1,
      lang: "vi",
      userToken,
      selectors: this.getSelectors(),
    };

    this.userWallet = {
      vouchers: [],
      pageInfo: null,
    };
    this.renderedVouchers = {};
    this.appliedDiscounts = [];
    this.isRemoving = false;
    this.init();
    this.fetchCartData();
    this.handleEmptyCartModal();
    this.reloadVoucherPopup();
    this.initCartObserver();
    this.setupCartItemListeners();
  }

  async reloadVoucherPopup() {
    const reload_btn = document.querySelector(".reload-page-btn");
    if (reload_btn) {
      reload_btn.style.cursor = "pointer";

      reload_btn.addEventListener("click", () => {
        window.location.reload();
        localStorage.setItem("reload-page", 1);
      });
    }

    window.addEventListener("DOMContentLoaded", () => {
      if (localStorage.getItem("reload-page")) {
        localStorage.removeItem("reload-page");
        setTimeout(() => {
          document.querySelector(".discount-code_popup")?.click();
        }, 500);
      }
    });

    window.addEventListener("click", (e) => {
      if (e.target !== reload_btn) {
        if (localStorage.getItem("reload-page")) {
          localStorage.removeItem("reload-page");
        }
      }
    });
  }

  async handleEmptyCartModal() {
    const url = new URL(window.location.href);
    const cartValue = url.searchParams.get("cart");
    const { emptyCartBox } = this.getSelectors();
    const closeBtn = document.querySelector(".empty-cart_close");
    const overlay = document.querySelector(".empty-cart_overlay");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        if (emptyCartBox.classList.contains("show-modal")) {
          emptyCartBox.classList.remove("show-modal");
        }
      });
    }
    if (overlay) {
      overlay.addEventListener("click", (e) => {
        if (emptyCartBox.classList.contains("show-modal")) {
          emptyCartBox.classList.remove("show-modal");
        }
      });
    }

    if (cartValue && cartValue === "empty") {
      emptyCartBox.classList.add("show-modal");
      console.log("The cart is empty");
    }
  }

  getSelectors() {
    return {
      vouchersList: document.querySelector(".discount-code_list"),
      codeInput: document.querySelector(".discount-code_apply input"),
      applyButton: document.querySelector(".discount-code_apply button"),
      popupButton: document.querySelector(".discount-code_popup"),
      closeButton: document.querySelector(".discount-code_close"),
      discountBox: document.querySelector(".discount-code-box"),
      emptyCartBox: document.querySelector(".empty-cart-popup"),
      overlay: document.querySelector(".discount-code_overlay"),
      voucherAppliedList: document.querySelector(
        ".cart__item-sub.cart__item-row.voucher-list"
      ),
      resetBtn: document.querySelector(".reset"),
      loadmoreBtn: document.querySelector(".load-more"),
      modalTokenList: document.querySelector(".discount-code_token-list"),
      money: document.querySelector(
        ".cart__item-sub.cart__item-row.cart-checkout-line div[data-subtotalfooter]"
      ),
      loginBtn: document.querySelector(".cart__item-sub.cart__item-row a"),
      applyBtn: document.querySelector(".apply-button"), // Đây là cái apply button để xác nhận các voucher sử dụng.
    };
  }

  async init() {
    this.handleLogout();
    this.setupEventListeners();
    if (this.config.userToken !== "") {
      await this.loadInitialData();
      this.removeVoucherApplied();
    } else {
      this.disableAllButton(true);
      await this.updateCartDiscountItem();
    }
  }

  async fetchCartData() {
    try {
      const response = await fetch("/cart.js");
      const cartData = await response.json();
      console.log("Cart Data:", cartData);

      if (cartData.total_discount && cartData.total_discount !== 0) {
        const discountElement = document.getElementById(
          "check_emptycart_discount"
        );
        if (discountElement) {
          discountElement.classList.remove("hidden");
        }
      }
    } catch (error) {
      console.error("Lỗi khi lấy cart data:", error);
    }
  }

  setupEventListeners() {
    const {
      popupButton,
      closeButton,
      overlay,
      applyButton,
      codeInput,
      resetBtn,
      loadmoreBtn,
      loginBtn,
      applyBtn,
    } = this.config.selectors;

    document.addEventListener("click", (e) => {
      const btn = e.target.closest('.discount-code_popup');
      if (btn) {
        this.togglePopup(e, true);
      }
    });
    closeButton?.addEventListener("click", () => this.togglePopup(null, false));
    overlay?.addEventListener("click", () => {
      this.togglePopup(null, false);
    });
    applyButton?.addEventListener("click", async (event) => {
      const { codeInput } = this.config.selectors;

      applyButton.disabled = true;

      try {
        await this.handleApplyDiscount(event);
        this.togglePopup(null, false);
      } finally {
        codeInput.value = "";
        applyButton.classList.remove("black-button");
        applyButton.disabled = true;
      }
    });
    codeInput?.addEventListener("input", (event) => {
      if (codeInput.value.trim() !== "") {
        applyButton.classList.add("black-button");
        applyButton.disabled = false;
      } else {
        applyButton.classList.remove("black-button");
        applyButton.disabled = true;
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") this.togglePopup(null, false);
    });
    resetBtn?.addEventListener("click", (event) => {
      event.preventDefault();
      this.showLoadingButton(resetBtn);

      this.loadDefaultVouchers(resetBtn, loadmoreBtn);
    });
    loadmoreBtn?.addEventListener("click", async (event) => {
      event.preventDefault();

      const isDisabled = this.checkButtonStatus(loadmoreBtn);
      if (isDisabled) return;

      this.showLoadingButton(loadmoreBtn);
      this.showModalSkeleton(1);
      await this.loadMoreAction(loadmoreBtn);
    });
    loginBtn?.addEventListener("click", () => {
      sessionStorage.setItem("redirectURL", window.location.href);
      window.location.href = window.theme.routes.accountLogin || "/account/login";
    });
    this.updateApplyBtnState();

    applyBtn?.addEventListener("click", async (event) => {
      event.preventDefault();

      this.showLoadingButton(applyBtn);

      try {
        const { discountArray } = this.getDiscountsLength();
        const selectedCodes = this.appliedDiscounts.map((v) => v.code);
        
        const manualCodes = discountArray.filter(code => !this.isThe1Coupon(code));
        const codesToRemove = discountArray.filter(code => 
          this.isThe1Coupon(code) && !selectedCodes.includes(code)
        );
        if (codesToRemove.length > 0) {
          await this.removeDiscountV2(codesToRemove);
        }

        const allCodesToApply = [...selectedCodes, ...manualCodes];

        await this.applyDiscountCode(allCodesToApply);
      } finally {
        this.removeLoadingButton(applyBtn);
        this.togglePopup(null, false);
      }
    });
  }

  isThe1Coupon(code) {
    if (!code) return false;
    const buCode = meowcart?.buCode || "crs";
    return (
      code.startsWith("THE1_") ||
      code.startsWith(`${buCode}_`) ||
      code.startsWith("POINT_")
    );
  }

  updateApplyBtnState() {
    const { applyBtn } = this.config.selectors;
    if (!applyBtn) return;

    const { discountArray } = this.getDiscountsLength();
    const the1VouchersInCart = discountArray.filter(code => this.isThe1Coupon(code));
    
    const pendingCount = this.appliedDiscounts.length;
    
    if (pendingCount === 0 && the1VouchersInCart.length === 0) {
      applyBtn.disabled = true;
      applyBtn.classList.add("disabled");
    } else {
      applyBtn.disabled = false;
      applyBtn.classList.remove("disabled");
    }
  }

  setupCartItemListeners() {
    document.addEventListener("click", (e) => {
      const removeLink = e.target.closest('a[href*="quantity=0"]');
      if (removeLink) {
        e.preventDefault();
        e.stopPropagation();
        
        const url = new URL(removeLink.href, window.location.origin);
        const id = url.searchParams.get("id");
        
        const allItems = Array.from(document.querySelectorAll('.cart__item'));
        const itemRow = removeLink.closest('.cart__item');
        const lineIndex = allItems.indexOf(itemRow) + 1;

        this.handleRemoveCartItem(id, lineIndex, itemRow);
      }
    }, true);

    document.addEventListener("change", (e) => {
      const qtyInput = e.target.closest('.js-qty__num');
      if (qtyInput) {
        const itemRow = qtyInput.closest('.cart__item');
        if (itemRow) {
          const bundleId = qtyInput.dataset.bundle_id || itemRow.dataset.bundle_id;
          if (bundleId) {
            const childRow = document.querySelector(`.cart__item.bundle__item__child[data-bundle_id="${bundleId}"]`);
            if (childRow) {
              childRow.classList.add('loading-spinner');
            }
          } else {
            itemRow.classList.add('loading-spinner');
          }
        }
      }
    }, true);
  }

  async handleRemoveCartItem(id, lineIndex, itemRow) {
    try {
      this.showSpinner();
      
      const qtyInput = itemRow?.querySelector('.js-qty__num');
      const variantId = qtyInput?.dataset?.variant_id || itemRow?.dataset?.variant_id || "";
      const bundleId = qtyInput?.dataset?.bundle_id || itemRow?.dataset?.bundle_id || "";
      const bundleTitleProperties = qtyInput?.dataset?.bundle_title_properties || itemRow?.dataset?.bundle_title_properties || "";
      
      if (itemRow) {
        itemRow.classList.add('loading-spinner');
      }

      let response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: 0 }),
      });

      if (!response.ok && lineIndex > 0) {
        console.warn("Key removal failed, trying line index:", lineIndex);
        response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: lineIndex, quantity: 0 }),
        });
      }

      if (!response.ok) {
        window.location.reload();
        return;
      }

      if (bundleId && window.XD) {
        if (window.XD.updateAddOns) {
          await window.XD.updateAddOns(variantId, bundleId, bundleTitleProperties);
        }
        if (window.XD.updateCartNoteFromBundles) {
          await window.XD.updateCartNoteFromBundles();
        }
      }

      if (itemRow && !bundleId) {
        itemRow.style.opacity = '0.5';
        itemRow.style.pointerEvents = 'none';
        itemRow.remove();
      }

      await this.updateCartDisplay();
      await this.checkAppliedDiscount();
    } catch (error) {
      console.error("AJAX removal error:", error);
      window.location.reload();
    } finally {
      this.hideSpinner();
    }
  }

  initCartObserver() {
    const targetNode = document.querySelector(".main-box-total");
    if (!targetNode) return;

    this.observer = new MutationObserver(
      this.debounce(async () => {
        console.log("Observer: Totals changed, syncing keys...");
        await this.updateCartDisplay();
      }, 500)
    );

    this.observer.observe(targetNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  async updateItemKeys() {
    try {
      const cartJson = await fetch("/cart.js").then(res => res.json());
      console.log("Cart JSON after update:", cartJson);
      if (!cartJson || !cartJson.items) return;

      const itemRows = document.querySelectorAll(".cart__item");
      itemRows.forEach((row, index) => {
        const itemData = cartJson.items[index];
        if (itemData) {
          row.setAttribute("data-key", itemData.key);
          
          row.querySelectorAll('[data-id]').forEach(el => el.setAttribute('data-id', itemData.key));
          
          row.querySelectorAll('a[href*="quantity=0"]').forEach(link => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set("id", itemData.key);
            link.href = url.pathname + url.search;
          });
        }
      });
      console.log("Keys synced successfully.");
    } catch (e) {
      console.error("Error syncing keys:", e);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  renderCustomToast({ type, timer, text }) {
    let icon = "";
    if (type === "success") {
      icon = `
				<span class="code-panel-numeric-icon">
					<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z" fill="#70C028"></path>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M19.8371 8.63495L11.1407 17.3313L5.85059 12.0412L7.61835 10.2734L11.1407 13.7958L18.0693 6.86719L19.8371 8.63495Z" fill="#F9F9F9"></path>
					</svg>
				</span>
				`;
    } else if (type === "error") {
      icon = `
				<span class="code-panel-numeric-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#C00F0C"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M17 18.7678L6 7.76777L7.76777 6L18.7678 17L17 18.7678Z" fill="white"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M5.99981 17L16.9998 6L18.7676 7.76777L7.76758 18.7678L5.99981 17Z" fill="white"/>
					</svg>
				</span>
			`;
    }

    if (!icon) {
      throw new Error(
        `${this.message.message().icon_type_not_found}: ${type}`
      );
    }

    const html = document.createElement("div");
    html.classList.add("custom-toast", "slide-in");
    html.classList.add(type);
    html.innerHTML = `${icon} ${text}`;
    document.body.appendChild(html);
    setTimeout(() => {
      html.classList.add("slide-back");
      html.addEventListener("animationend", () => {
        document.body.removeChild(html);
      });
    }, timer);
  }

  async loadDefaultVouchers(btnReset, btnLoadMore) {
    const { vouchersList } = this.config.selectors;

    this.userWallet.vouchers = [];
    this.userWallet.pageInfo = null;

    vouchersList.innerHTML = "";

    try {
      const { vouchers, pageInfo } = await this.fetchMyCoupons(null, "next", true);

      this.userWallet.pageInfo = pageInfo;
      this.checkButtonStatus(btnLoadMore);
      this.renderLoadMoreVouchers(vouchers);
    } catch (error) {
      console.error("Error reset vouchers:", error);
    } finally {
      this.removeLoadingButton(btnReset);
    }
  }

  async loadMoreAction(btn) {
    if (this.userWallet.pageInfo?.hasNextPage) {
      const nextPageCursor = this.userWallet.pageInfo?.cursor;

      try {
        const { vouchers, pageInfo } = await this.fetchMyCoupons(
          nextPageCursor,
          "next",
          false
        );

        if (vouchers.length > 0) {
          this.userWallet.pageInfo = pageInfo;
          const { discountArray } = this.getDiscountsLength();

          if (this.appliedDiscounts.length < 0) {
            this.appliedDiscounts = this.userWallet.vouchers.filter((voucher) =>
              discountArray.includes(voucher.code)
            );
          }

          this.checkButtonStatus(btn);
          this.renderLoadMoreVouchers(vouchers);

          if (discountArray.length > 0) {
            const discountCount = this.getDiscountsLength().count;
            console.log(discountCount);
            const checkboxes = document.querySelectorAll(
              ".discount-checkbox-item"
            );

            if (discountCount === 5) {
              let currentDiscounts = [];
              const appliedDiscount =
                this.getDiscountsLength()["discountArray"];

              appliedDiscount.forEach((code) => {
                currentDiscounts.push(code);
              });
              this.appliedDiscounts
                .filter((voucher) => !voucher.applied)
                .forEach((el) => {
                  currentDiscounts.push(el.code);
                });

              checkboxes.forEach((checkbox) => {
                const data_code = checkbox.getAttribute("data-code");
                if (!currentDiscounts.includes(data_code)) {
                  checkbox.classList.add("disabled");
                  checkbox.parentElement.classList.add("disabled");
                }
              });
            } else {
              checkboxes.forEach((checkbox) => {
                if (checkbox.classList.contains("disabled")) {
                  checkbox.classList.remove("disabled");
                  checkbox.parentElement.classList.remove("disabled");
                }
              });
            }
            discountArray.forEach(async function (discount) {
              let checkboxed = document.querySelector(
                `[data-code = ${discount}].discount-code_item .discount-checkbox-item`
              );
              if (checkboxed && !checkboxed.checked) {
                checkboxed.checked = true;
              }
            });
          }
        } else {
          console.log("No voucher");
        }
      } catch (error) {
        console.error("Error loading more vouchers:", error);
      } finally {
        this.removeLoadingButton(btn);
        this.removeModalSkeleton();
        const checkboxes = document.querySelectorAll(".discount-checkbox-item");
        const appliedFalseCount = this.appliedDiscounts.filter(
          (voucher) => !voucher.applied
        );

        if (appliedFalseCount.length === 5) {
          let currentDiscounts = [];
          appliedFalseCount.forEach((el) => {
            currentDiscounts.push(el.code);
          });

          checkboxes.forEach((checkbox) => {
            const data_code = checkbox.getAttribute("data-code");
            if (!currentDiscounts.includes(data_code)) {
              checkbox.classList.add("disabled");
              checkbox.parentElement.classList.add("disabled");
            }
          });
        }
      }
    }
  }

  checkButtonStatus(btn) {
    if (!this.userWallet.pageInfo?.hasNextPage) {
      btn.disabled = true;
      return true;
    }
    btn.disabled = false;
    return false;
  }

  renderLoadMoreVouchers(vouchers) {
    const { vouchersList } = this.config.selectors;
    if (!vouchersList) return;

    vouchers.forEach((voucher, index) => {
      const item = this.renderCampaignItem(voucher, index);
      vouchersList.appendChild(item);
    });

    this.checkLoadMoreAppliedYet();
  }

  showLoadingButton(button) {
    button.classList.add("btn-loading");
    button.style.pointerEvents = "none";
  }

  removeLoadingButton(button) {
    button.classList.remove("btn-loading");
    button.style.pointerEvents = "";
  }

  async togglePopup(event, open) {
    if (event) event.preventDefault();
    const { discountBox, codeInput, loadmoreBtn } = this.config.selectors;
    const termsModal = document.getElementById("termsModal");
    if (open) {
      this.updateApplyBtnState();
      if (loadmoreBtn) {
        this.checkButtonStatus(loadmoreBtn);
      }
      discountBox.classList.add("show-modal");
      document.documentElement.classList.add("no-scroll");
      document.body.classList.add("no-scroll");
      const discountCount = this.getDiscountsLength().count;
      console.log(discountCount);
      const checkboxes = document.querySelectorAll(".discount-checkbox-item");

      if (discountCount === 5) {
        let currentDiscounts = [];
        const appliedDiscount = this.getDiscountsLength()["discountArray"];

        appliedDiscount.forEach((code) => {
          currentDiscounts.push(code);
        });
        this.appliedDiscounts
          .filter((voucher) => !voucher.applied)
          .forEach((el) => {
            currentDiscounts.push(el.code);
          });

        checkboxes.forEach((checkbox) => {
          const data_code = checkbox.getAttribute("data-code");
          if (!currentDiscounts.includes(data_code)) {
            checkbox.classList.add("disabled");
            checkbox.parentElement.classList.add("disabled");
          }
        });
      } else {
        checkboxes.forEach((checkbox) => {
          if (checkbox.classList.contains("disabled")) {
            checkbox.classList.remove("disabled");
            checkbox.parentElement.classList.remove("disabled");
          }
        });
      }
    } else {
      discountBox.classList.remove("show-modal");
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
      codeInput.value = "";
      if (termsModal) {
        termsModal.style.display = "none";
      }
      this.removeAllCheckbox();
    }
    // document.documentElement.classList.toggle("no-scroll", open);
  }

  removeAllCheckbox() {
    const checkboxes = document.querySelectorAll(".discount-checkbox-item");

    checkboxes.forEach((checkbox) => {
      const parentItem = checkbox.closest(".discount-code_item");
      const code = parentItem?.getAttribute("data-code");

      const isApplied = this.appliedDiscounts.some(
        (voucher) => voucher.code === code && voucher.applied
      );

      // Cập nhật trạng thái checkbox
      checkbox.checked = isApplied;
    });

    this.appliedDiscounts = this.appliedDiscounts.filter(
      (voucher) => voucher.applied
    );
  }

  updateModalTokenListVisibility() {
    const items =
      this.config.selectors.modalTokenList.querySelectorAll(".items");
    if (items.length > 0) {
      this.config.selectors.modalTokenList.classList.remove("hidden");
    } else {
      this.config.selectors.modalTokenList.classList.add("hidden");
    }
  }

  handleVoucherCheckboxes() {
    this.setUpVoucherCheckboxListener();
    this.handleTcsClick();
  }

  handleTcsClick() {
    const termsModal = document.getElementById("termsModal");
    if (!termsModal) return;

    const discountTerms = termsModal.querySelector(".discount-terms");
    const closeBtn = document.getElementById("closeModal");
    const overlay = termsModal.querySelector(".discount-terms_overlay");

    // Click on terms link inside voucher items (using delegation for dynamic content)
    document.addEventListener("click", (e) => {
      const item = e.target.closest(".terms-link");
      if (item) {
        const text = item.getAttribute("data-tcs") || "";
        const images = item.getAttribute("data-images-tcs") || "";

        const contentInner = this.convertTextToLiTag(text, images);

        if (discountTerms) discountTerms.innerHTML = contentInner;
        if (termsModal) {
          termsModal.style.display = "block";
          document.documentElement.classList.add("no-scroll");
          document.body.classList.add("no-scroll");
        }
      }
    });

    const closeTermsModal = () => {
      if (termsModal) {
        termsModal.style.display = "none";
        document.documentElement.classList.remove("no-scroll");
        document.body.classList.remove("no-scroll");
      }
    };

    closeBtn?.addEventListener("click", (e) => {
      e.stopPropagation();
      closeTermsModal();
    });

    overlay?.addEventListener("click", (e) => {
      e.stopPropagation();
      closeTermsModal();
    });
    
    // Also close on Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && termsModal.style.display === "block") {
        closeTermsModal();
      }
    });
  }

  convertTextToLiTag(voucherText, images = "") {
    const voucherItems = voucherText.includes("•")
      ? voucherText
          .split("•")
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
      : voucherText
          .split("\n")
          .map((item) => item.trim())
          .filter((item) => item.length > 0);

    const voucherList = document.createElement("ul");
    voucherList.classList.add("voucher-details-note");

    voucherItems.forEach((item) => {
      const li = document.createElement("li");
      li.classList.add("voucher-details-txt");
      li.textContent = item;
      voucherList.appendChild(li);
    });

    if (images) {
      const imageArray = images
        .split(",")
        .map((img) => img.trim())
        .filter((img) => img.length > 0);

      if (imageArray.length > 0) {
        const imageContainer = document.createElement("div");
        imageContainer.classList.add("container-image");

        imageArray.forEach((imgSrc) => {
          const img = document.createElement("img");
          img.src = imgSrc;
          img.alt = "voucher image";
          imageContainer.appendChild(img);
        });

        voucherList.appendChild(imageContainer);
      }
    }

    return voucherList.outerHTML;
  }

  setUpVoucherCheckboxListener() {
    const checkboxes = document.querySelectorAll(".discount-checkbox-item");

    checkboxes.forEach((checkbox) => {
      const parentItem = checkbox.closest(".discount-code_item");
      const currentParentStyle = getComputedStyle(parentItem);
      checkbox.parentElement.style.height = `${currentParentStyle["height"]}`;
      const code = parentItem?.getAttribute("data-code");
      const isCodeApplied = this.appliedDiscounts.some(
        (appliedVoucher) => appliedVoucher.code === code
      );

      checkbox.checked = isCodeApplied;

      checkbox.addEventListener("change", async () => {
        if (this.isRemoving) return;
        if (code) {
          try {
            this.isRemoving = true;
            this.disableAllRemoveButtons(true);
            if (checkbox.checked) {
              const foundVoucher = this.appliedDiscounts.find(
                (voucher) => voucher.code === code
              );

              if (!foundVoucher) {
                const voucher = this.userWallet.vouchers.find(
                  (voucher) => voucher.code === code
                );

                if (voucher) {
                  voucher.applied = false;
                  this.appliedDiscounts.push(voucher);
                }
              }

              const appliedFalseCount = this.appliedDiscounts.filter(
                (voucher) => !voucher.applied
              ).length;
              const discountCount = this.getDiscountsLength().count;
              const currentCount = discountCount + appliedFalseCount;
              if (currentCount === 5) {
                let currentDiscounts = [];
                const appliedDiscount =
                  this.getDiscountsLength()["discountArray"];

                appliedDiscount.forEach((code) => {
                  currentDiscounts.push(code);
                });
                this.appliedDiscounts
                  .filter((voucher) => !voucher.applied)
                  .forEach((el) => {
                    currentDiscounts.push(el.code);
                  });

                console.log("CurrentDiscounts: " + currentDiscounts);

                checkboxes.forEach((checkbox) => {
                  const data_code = checkbox.getAttribute("data-code");
                  if (!currentDiscounts.includes(data_code)) {
                    checkbox.classList.add("disabled");
                    checkbox.parentElement.classList.add("disabled");
                  }
                });
                return;
              } else if (currentCount > 5) {
                this.appliedDiscounts.pop();
                let currentDiscounts = [];
                const appliedDiscount =
                  this.getDiscountsLength()["discountArray"];

                appliedDiscount.forEach((code) => {
                  currentDiscounts.push(code);
                });
                this.appliedDiscounts
                  .filter((voucher) => !voucher.applied)
                  .forEach((el) => {
                    currentDiscounts.push(el.code);
                  });
                checkbox.checked = false;
                checkboxes.forEach((checkbox) => {
                  const data_code = checkbox.getAttribute("data-code");
                  if (!currentDiscounts.includes(data_code)) {
                    checkbox.classList.add("disabled");
                    checkbox.parentElement.classList.add("disabled");
                  }
                });
                return;
              } else {
                checkboxes.forEach((checkbox) => {
                  if (checkbox.classList.contains("disabled")) {
                    checkbox.classList.remove("disabled");
                    checkbox.parentElement.classList.remove("disabled");
                  }
                });
              }
            } else {
              this.appliedDiscounts = this.appliedDiscounts.filter(
                (voucher) => voucher.code !== code
              );

              checkboxes.forEach((checkbox) => {
                if (checkbox.classList.contains("disabled")) {
                  checkbox.classList.remove("disabled");
                  checkbox.parentElement.classList.remove("disabled");
                }
              });
            }
          } finally {
            this.isRemoving = false;
            this.disableAllRemoveButtons(false);
            this.updateApplyBtnState();
          }
        }
      });
    });
  }

  async loadInitialData() {
    try {
      this.showModalSkeleton(3);
      const { vouchers, pageInfo } = await this.fetchMyCoupons(null, "next", true);

      const discountCodeBottom = document.querySelectorAll(".discount-code_bottom");
      if (vouchers.length === 0) {
        discountCodeBottom.forEach(item => item.style.display = "none");
      } else {
        discountCodeBottom.forEach(item => item.style.display = "");
      }

      const couponDetailsPromises = this.userWallet.vouchers.map((coupon) =>
        this.fetchCouponDetail(coupon.shopifyDiscount?.id_token)
      );
      await Promise.all(couponDetailsPromises);
      this.renderMyCoupons();
      this.checkAppliedDiscount();
      this.checkButtonStatus(this.config.selectors.loadmoreBtn);
      this.checkButtonStatus(this.config.selectors.resetBtn);
    } catch (error) {
      console.log('loadInitialData error', error);
      
      this.handleError(
        `${this.message.message().failed_load_list_voucher}`,
        error
      );
    } finally {
      this.removeModalSkeleton();
    }
  }

  async fetchData(endpoint, body = {}, params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    let url = `${this.provider.hostName}${endpoint}${
      queryParams ? "?" + queryParams : ""
    }`;
    if (url.includes("/the1/shopify")) {
      url = url.replace("/the1/shopify", "/shopify");
    }
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-User-Token": this.config.userToken,
        },
        body: JSON.stringify(body),
      });

      let result;
      try {
        result = await response.json();
      } catch (e) {
        result = null;
      }

      if (!response.ok) {
        // Tạo một object lỗi có cấu trúc giống Axios để tương thích với logic catch hiện tại
        const error = new Error(`HTTP error! status: ${response.status}`);
        error.response = {
          status: response.status,
          data: result
        };
        throw error;
      }

      const errorCodes = result?.error_fields || [];
      if (errorCodes.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }

      if (!result.status)
        throw new Error(
          result.message || `${this.message.message().error}`
        );
      return result;
    } catch (error) {
      const errorCodes = error?.response?.data?.error_fields || [];
      if (errorCodes.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
      }
      
      throw error;
    }
  }

  async synchronizeCoupons() {
    try {
      const response = await this.fetchData(
        this.apiEndPoint.synchronizeCoupons,
        {},
        {}
      );

      return response;
    } catch (error) {
      const errorCodes = error?.response?.data?.error_fields || [];
      
      if (errorCodes.includes(956)) {
        
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }
    }
  }

  async fetchMyCoupons(cursor = null, action = "next", firstPage = false) {
    const sync = await this.synchronizeCoupons();

    if (sync) {
      const data = await this.fetchData(
        this.apiEndPoint.getMyCoupons,
        {},
        {
          usageChannel: "Online,Instore",
          cursor: cursor,
          action: action,
          firstPage: firstPage,
          status: "active",
          pageSize: 12,
        }
      );
      console.log('here: data', data);
      

      this.userWallet.vouchers = [
        ...(this.userWallet.vouchers || []),
        ...(data?.data || []),
      ];
      this.userWallet.pageInfo = data?.pageInfo;

      return {
        vouchers: data?.data || [],
        pageInfo: data?.pageInfo || null,
      };
    }
  }

  async fetchCouponDetail(idToken) {
    if (!idToken) {
      return;
    }

    const data = await this.fetchData(
      this.apiEndPoint.getCouponDetail,
      {
        id_token: idToken,
      },
      {}
    );
  }

  async applyDiscountNonLogin(discounts) {
    this.showSkeleton();
    this.updateModalTokenListVisibility();

    const response = await this.addDiscountV2(discounts);
    const { discountArray } = this.getDiscountsLength();
    const codesNotApplied = discounts.filter(
      (code) => !discountArray.includes(code)
    );

    const handleCodesNotApplied = async () => {
      if (codesNotApplied.length > 0) {
        const codesText = codesNotApplied.join(", ");
        this.renderCustomToast({
          type: "error",
          text: `${codesText} ${this.message.cart().can_not_apply}`,
          timer: 5000,
        });

        codesNotApplied.forEach((value) => {
          const input = document.querySelector(`input[data-code= "${value}"]`);
          input.classList.add("disabled");
          console.log(input);
          let currElement = document.querySelector(
            `[data-code="${value}"] .discount-checkbox-item`
          );
          if (currElement) currElement.checked = false;
        });
      }
    };

    const handleCodesApplied = async () => {
      const codesText = discounts.join(", ");
      this.renderCustomToast({
        type: "success",
        text: `${codesText} ${this.message.cart().apply_success}`,
        timer: 5000,
      });
    };

    if (!response) {
      this.togglePopup(null, false);
      await handleCodesNotApplied();
      this.removeSkeleton();
    } else {
      // await this.updateCartDiscountItem();
      this.removeSkeleton();
      this.togglePopup(null, false);
      await handleCodesApplied();
    }
  }

  async applyDiscountCode(discounts) {
    this.disableAllButton(true);
    this.clearInnerContent();
    this.showSkeleton();
    this.updateModalTokenListVisibility();

    const response = await this.addDiscountV2(discounts);
    const { discountArray } = this.getDiscountsLength();
    const codesNotApplied = discounts.filter(
      (code) => !discountArray.includes(code)
    );
    const updateVoucherStatus = () => {
      this.appliedDiscounts.forEach((voucher) => {
        if (discountArray.includes(voucher.code)) {
          voucher.applied = true;
        }
      });
    };
    const handleCodesNotApplied = async () => {
      if (codesNotApplied.length > 0) {
        this.renderCustomToast({
          type: "error",
          text: `${codesNotApplied.join(
            ", "
          )} ${this.message.cart().can_not_apply}`,
          timer: 5000,
        });

        codesNotApplied.forEach((value) => {
          const input = document.querySelector(`input[data-code= "${value}"]`);
          input.classList.add("disabled");
          let currElement = document.querySelector(
            `[data-code="${value}"] .discount-checkbox-item`
          );
          if (currElement) currElement.checked = false;
        });
      }
    };

    if (!response) {
      updateVoucherStatus();
      this.removeSkeleton();
      // await this.handleRenderDiscountApplied();
      await handleCodesNotApplied();
      this.disableAllButton(false);
    } else {
      updateVoucherStatus();
      this.removeSkeleton();
      // await this.handleRenderDiscountApplied();
      await handleCodesNotApplied();
      this.disableAllButton(false);
    }
    // Remove vouchers with `applied = false`
    this.appliedDiscounts = this.appliedDiscounts.filter(
      (voucher) => voucher.applied
    );
  }

  renderMyCoupons() {
    const { vouchersList } = this.config.selectors;
    if (!vouchersList) return;

    const voucherModal = document.querySelector(
      "discount-code-box .content-popup-box.padding-popup.height-popup"
    );

    if (this.userWallet.vouchers.length < 1) {
      vouchersList.classList.add("height-0");
      voucherModal.classList.add("height-empty");
    } else {
      if (vouchersList.classList.contains("height-0")) {
        vouchersList.classList.remove("height-0");
      }

      if (voucherModal.classList.contains("height-empty")) {
        voucherModal.classList.remove("height-0");
      }
    }

    this.userWallet.vouchers.forEach((coupon, index) => {
      console.log("Checkedd");
      if (coupon && coupon.details) {
        const usageChannels = coupon.details.content.usage_channels;

        if (
          usageChannels &&
          !(usageChannels.length === 1 && usageChannels[0] === "At Store")
        ) {
          const item = this.renderCampaignItem(coupon, index);
          vouchersList.appendChild(item);
        } else {
          return;
        }
      } else {
        console.error("Dữ liệu không hợp lệ:", coupon);
        return "";
      }
    });
  }

  formatNumber(number) {
    if (number === null || number === undefined) {
      return null;
    }

    return new Intl.NumberFormat("vi-VN").format(number);
  }

  renderCampaignItem(campaign, index) {
    const message = new MeowcartLoyaltyMessage();
    const campaignId = String(campaign.details.campaignId);
    const content = campaign.details.content;
    const reward = campaign.details.reward;
    const currentLanguage = message.currentLang;
    const title =
      currentLanguage === "VI"
        ? content.vi?.title || `${this.message.message().no_title}`
        : content.en?.title || `${this.message.message().no_title}`;
    const point = this.formatNumber(content?.condition?.point) || null;
    const reward_value = this.formatNumber(campaign?.reward_value) || null;
    const desc =
      currentLanguage === "VI"
        ? content.vi?.desc || `${this.message.message().no_description}`
        : content.en?.desc ||
          `${this.message.message().no_description}`;
    const code = campaign?.code;
    const endDate = campaign?.valid_to;
    const isChecked = this.appliedDiscounts.some(
      (discount) =>
        discount.details.campaignId === campaign.details.campaignId &&
        discount.code === campaign.code
    );
    const tcs_images = Object.values(campaign?.details?.content?.images || {});
    const tcs =
      currentLanguage === "VI"
        ? content.vi?.tcs || `${this.message.message().no_tcs}`
        : content.en?.tcs || `${this.message.message().no_tcs}`;
    const item = document.createElement("div");
    item.classList.add("discount-code_item", "active");
    item.dataset.campaignId = campaignId;
    item.dataset.code = code;
    item.innerHTML = `
			<div class="discount-code_checkbox">
				<input id="my-discount-${campaignId}-${index}" type="checkbox" class="discount-checkbox-item" data-code=${code} value="" ${
      isChecked ? "checked" : ""
    }>
        <label for="my-discount-${campaignId}-${index}"></label>
				<span class="checkbox-pseudo"></span>
				<span class="checkmark"></span>
			</div>
			<div class="discount-code_image object-fit-contain">
				<img src="${
          content.image ||
          "https://cdn.shopify.com/s/files/1/0696/3783/2958/files/image-2.jpg?v=1726898801"
        }" alt="Voucher image">
			</div>
			<div class="discount-code_content flex-col-between">
				<div class="discount-code_expiry">${this.message.voucher().expiration_date_label}: ${this.formatDate(
          endDate
        )}</div>
				${
          Number(reward) !== 1
            ? `<span class="discount-code_name h-0" data-code=${code}>${title}</span>`
            : `<span class="discount-code_name h-0" data-code=${code}>${this.message.voucher().discount_voucher} [${reward_value} VND] ${this.message.voucher().at_central_retail}</span>`
        }
				<div class="discount-code_id">
					<span class="discount-code_text">${code}</span>
				</div>
				<span class="discount-code_des">${desc}</span>
				<p class="terms-link" data-images-tcs="${tcs_images}" data-tcs="${tcs}">${this.message.voucher().terms_conditions}</p>
				<button style="display:none;" type="button" class="use-voucher-btn ${
          isChecked ? "" : "active"
        }"
					${isChecked ? "disabled" : ""}
				>${
          isChecked
            ? `${this.message.voucher().in_use}`
            : `${this.message.voucher().use}`
        }</button>
			</div>
		`;

    return item;
  }

  updateBtnStatus(item, status) {
    const btn = item.querySelector("button");

    if (status === "add") {
      btn.textContent = `${this.message.voucher().in_use}`;
      btn.classList.remove("active");
      btn.disabled = true;
    } else if (status === "remove") {
      btn.textContent = `${this.message.voucher().use}`;
      btn.classList.add("active");
      btn.disabled = false;
    }
  }

  async handleRenderDiscountApplied() {
    this.handleRenderCodeItem();
    await this.updateCartDiscountItem();
  }

  async updateCartDiscountItem() {
    const { voucherAppliedList } = this.getSelectors();

    try {
      const response = await fetch(`${this.root}cart`.replace(/\/+$/, "/")).then((res) => res.text());
      const parser = new DOMParser();
      const doc = parser.parseFromString(response, "text/html");

      voucherAppliedList.innerHTML = doc.querySelector(
        ".cart__item-sub.cart__item-row.voucher-list"
      ).innerHTML;

      const items = voucherAppliedList.querySelectorAll(".items");

      items.forEach((item) => {
        const removeButton = item.querySelector(".remove-voucher");
        const code = item.querySelector(".voucher-code").textContent.trim();
        removeButton.addEventListener("click", async () => {
          if (this.isRemoving) return;

          try {
            this.isRemoving = true;
            this.disableAllRemoveButtons(true);
            await this.handleRemoveVoucher(code);
          } finally {
            this.isRemoving = false;
            this.disableAllRemoveButtons(false);
          }
        });
      });
    } catch (error) {
      console.error("Error updating cart display:", error);
    }
  }

  pushListCodeElementChange(code) {
    const { modalTokenList } = this.getSelectors();

    const item = this.renderCampaignCode(code);
    modalTokenList.appendChild(item);

    const newItem = modalTokenList.querySelector(`[data-code="${code}"]`);

    if (newItem) {
      const item = newItem.querySelector(".remove-voucher");
      if (item) {
        item.addEventListener("click", async () => {
          if (this.isRemoving) return;

          try {
            this.isRemoving = true;
            this.disableAllRemoveButtons(true);
            await this.handleRemoveVoucher(code);
          } finally {
            this.isRemoving = false;
            this.disableAllRemoveButtons(false);
          }
        });
      }
    }

    this.renderedVouchers[code] = {
      render: true,
    };
  }

  clearInnerContent() {
    const { voucherAppliedList, modalTokenList } = this.getSelectors();

    if (voucherAppliedList) {
      voucherAppliedList.innerHTML = "";
    }
    if (modalTokenList) {
      modalTokenList.innerHTML = "";
    }
  }

  renderCampaignCode(code) {
    const item = document.createElement("div");
    item.classList.add("items");
    item.setAttribute("data-code", code);
    item.innerHTML = `
				<span>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      					<path d="M4.66634 4.66671H4.67301M13.7263 8.94004L8.94634 13.72C8.82251 13.844 8.67546 13.9424 8.5136 14.0095C8.35173 14.0766 8.17823 14.1111 8.00301 14.1111C7.82779 14.1111 7.65429 14.0766 7.49242 14.0095C7.33056 13.9424 7.18351 13.844 7.05967 13.72L1.33301 8.00004V1.33337H7.99967L13.7263 7.06004C13.9747 7.30986 14.1141 7.64779 14.1141 8.00004C14.1141 8.35229 13.9747 8.69022 13.7263 8.94004Z" stroke="#006DA4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    				</svg>
				</span>
				<span class="voucher-code">${code}</span>
				<span class="remove-voucher">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      					<path d="M12 4L4 12M4 4L12 12" stroke="#B2B2B2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>	
				</span>
		`;

    return item;
  }

  async handleApplyDiscount(event) {
    if (event) event.preventDefault();
    const { codeInput } = this.config.selectors;
    const { count } = this.getDiscountsLength();

    if (count >= 5) {
      this.renderCustomToast({
        type: "error",
        text: `${this.message.customToast().cart_over_5}`,
        timer: 3000,
      });
      return;
    }

    if (codeInput?.value.trim()) {
      const { discountArray } = this.getDiscountsLength();
      const code = codeInput.value.trim();

      if (discountArray.includes(code)) return;

      const discountCodes = [...discountArray, code];

      if (this.config.userToken !== "") {
        await this.applyDiscountCode(discountCodes);
        this.removeAllCheckbox();
        this.appliedDiscountCheckboxStatus(code);
      } else {
        await this.applyDiscountNonLogin(discountCodes);
      }
    }
  }

  appliedDiscountCheckboxStatus(code) {
    const { vouchersList } = this.getSelectors();
    const item = vouchersList.querySelector(`[data-code="${code}"]`);

    if (item) {
      const checkbox = item.querySelector(".discount-code_checkbox input");

      if (checkbox) {
        const isApplied = this.appliedDiscounts.some(
          (voucher) => voucher.code === code
        );

        checkbox.checked = isApplied;
      }

      this.getDiscountsLength()["discountArray"].forEach((discount) => {
        const currCheckbox = document.querySelector(
          `input[data-code='${discount}']`
        );
        if (!currCheckbox.checked) {
          currCheckbox.checked = true;
        }
      });

      if (this.getDiscountsLength()["count"] === 5) {
        console.log("Running if");
        const checkboxes = document.querySelectorAll(".discount-checkbox-item");

        checkboxes.forEach((checkbox) => {
          const data_code = checkbox.getAttribute("data-code");
          if (!this.getDiscountsLength()["discountArray"].includes(data_code)) {
            checkbox.classList.add("disabled");
            checkbox.parentElement.classList.add("disabled");
          }
        });
      }
    }
  }

  updateVoucherStatus(button, status) {
    const allButtons = document.querySelectorAll(".use-voucher-btn");

    allButtons.forEach((btn) => {
      if (!btn.disabled) {
        btn.textContent = `${this.message.voucher().use}`;
        btn.disabled = false;
      }
    });

    if (status === "applied" && button) {
      button.textContent = `${this.message.voucher().applied}`;
    } else if (status === "error") {
    }
  }

  formatDate(dateString) {
    if (!dateString)
      return `${this.message.message().no_information_available}`;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return `${this.message.message().invalid_date}`;
    return date.toLocaleDateString("vi-VN");
  }

  handleError(message, error) {
    console.error(message, error);
    this.errors.push(error);
  }

  getDiscountsLength() {
    const discountInput = document.querySelector('input[name="discount"]');
    const discountValues = discountInput.value;
    const discountArray = discountValues.split(",").filter(Boolean);
    const count = discountArray.length;

    return { discountArray: discountArray, count: count };
  }

  getAppliedDiscounts() {
    const { discountArray } = this.getDiscountsLength();
    const manuallySelected = this.appliedDiscounts.filter(v => !v.applied);

    const currentlyAppliedMap = new Map();
    this.userWallet.vouchers
      .filter((voucher) => discountArray.includes(voucher.code))
      .forEach(v => {
          currentlyAppliedMap.set(v.code, { ...v, applied: true });
      });
      
    this.appliedDiscounts = [
        ...currentlyAppliedMap.values(),
        ...manuallySelected.filter(v => !currentlyAppliedMap.has(v.code))
    ];
  }

  checkLoadMoreAppliedYet() {
    this.handleVoucherCheckboxes();
  }

  checkAppliedDiscount() {
    this.getAppliedDiscounts();
    this.renderCampaignCodeItem();
    this.handleVoucherCheckboxes();
  }

  renderCampaignCodeItem() {
    const { modalTokenList } = this.getSelectors();
    if (modalTokenList) modalTokenList.innerHTML = "";
    this.handleRenderCodeItem();
    this.updateModalTokenListVisibility();
  }

  handleRenderCodeItem() {
    const { discountArray, count } = this.getDiscountsLength();

    discountArray.forEach((discount) => {
      this.pushListCodeElementChange(discount);
    });
  }

  async handleRemoveVoucher(code) {
    try {
      // const { vouchersList, modalTokenList, voucherAppliedList } =
      //   this.getSelectors();

      // const modalItem = modalTokenList.querySelector(`[data-code="${code}"]`);
      // if (modalItem) {
      //   modalItem.remove();
      // }

      // const appliedVoucherItems = voucherAppliedList.querySelectorAll(".items");

      // appliedVoucherItems.forEach((item) => {
      //   const voucherCodeElement = item.querySelector(".voucher-code");
      //   if (
      //     voucherCodeElement &&
      //     voucherCodeElement.textContent.trim() === code
      //   ) {
      //     item.remove();
      //   }
      // });

      // const item = vouchersList.querySelector(
      //   `.discount-code_item[data-code="${code}"]`
      // );

      // if (item) {
      //   const checkbox = item.querySelector(`.discount-checkbox-item`);
      //   checkbox.checked = false;
      // }

      // if (this.renderedVouchers[code]) {
      //   delete this.renderedVouchers[code];
      // }

      const discountCodes = [code];

      // this.appliedDiscounts = this.appliedDiscounts.filter((voucher) => {
      //   return !(voucher.code === code);
      // });

      // this.updateModalTokenListVisibility();

      await this.removeDiscountV2(discountCodes);
    } catch (error) {
      console.error("Error removing voucher:", error);
    }
  }

  async handleRemoveMultipleVouchers(codes) {
    try {
      // const { vouchersList, modalTokenList, voucherAppliedList } =
      //   this.getSelectors();

      // codes.forEach((code) => {
      //   const modalItem = modalTokenList.querySelector(`[data-code="${code}"]`);
      //   if (modalItem) {
      //     modalItem.remove();
      //   }

      //   const appliedVoucherItems = voucherAppliedList.querySelectorAll(".items");

      //   appliedVoucherItems.forEach((item) => {
      //     const voucherCodeElement = item.querySelector(".voucher-code");
      //     if (
      //       voucherCodeElement &&
      //       voucherCodeElement.textContent.trim() === code
      //     ) {
      //       item.remove();
      //     }
      //   });

      //   const item = vouchersList.querySelector(
      //     `.discount-code_item[data-code="${code}"]`
      //   );

      //   if (item) {
      //     const checkbox = item.querySelector(`.discount-checkbox-item`);
      //     checkbox.checked = false;
      //   }

      //   if (this.renderedVouchers[code]) {
      //     delete this.renderedVouchers[code];
      //   }
      // });

      // this.appliedDiscounts = this.appliedDiscounts.filter((voucher) => {
      //   return !codes.includes(voucher.code);
      // });

      // this.updateModalTokenListVisibility();

      await this.removeDiscountV2(codes);
    } catch (error) {
      console.error("Error removing vouchers:", error);
    }
  }

  removeVoucherApplied() {
    const { voucherAppliedList } = this.getSelectors();
    const vouchers = voucherAppliedList.querySelectorAll(".items");

    if (vouchers) {
      vouchers.forEach((voucher) => {
        const removeIcon = voucher.querySelector(".remove-voucher");

        if (removeIcon) {
          removeIcon.addEventListener("click", async (event) => {
            event.stopPropagation();

            if (this.isRemoving) return;

            try {
              this.isRemoving = true;
              this.disableAllRemoveButtons(true);

              const code = voucher
                .querySelector(".voucher-code")
                .textContent.trim();

              await this.handleRemoveVoucher(code);
            } finally {
              this.isRemoving = false;
              this.disableAllRemoveButtons(false);
            }
          });
        }
      });
    }
  }

  disableAllButton(disabled) {
    const { applyBtn, loadmoreBtn } = this.getSelectors();

    if (applyBtn) {
      applyBtn.disabled = disabled;
      if (loadmoreBtn) {
        loadmoreBtn.disabled = disabled;
      }
    }
  }

  disableAllRemoveButtons(disabled) {
    const { applyBtn } = this.getSelectors();
    const removeIcons =
      this.config.selectors.voucherAppliedList.querySelectorAll(
        ".remove-voucher"
      );
    const removeIconsInModal =
      this.config.selectors.modalTokenList.querySelectorAll(".remove-voucher");
    const checkboxItems = this.config.selectors.vouchersList.querySelectorAll(
      ".discount-code_checkbox input"
    );

    removeIcons.forEach((icon) => {
      icon.style.pointerEvents = disabled ? "none" : "auto";
      icon.classList.toggle("disabled", disabled);
    });

    if (removeIconsInModal) {
      removeIconsInModal.forEach((icon) => {
        icon.style.pointerEvents = disabled ? "none" : "auto";
        icon.classList.toggle("disabled", disabled);
      });
    }

    if (checkboxItems) {
      checkboxItems.forEach((checkbox) => {
        checkbox.disabled = disabled;
      });
    }

    if (applyBtn) {
      applyBtn.disabled = disabled;
    }
  }

  showSkeleton() {
    const { voucherAppliedList, modalTokenList } = this.getSelectors();

    if (voucherAppliedList) {
      const item = document.createElement("div");
      item.classList.add("items", "shimmer");
      voucherAppliedList.appendChild(item);
    }

    if (modalTokenList) {
      const item = document.createElement("div");
      item.classList.add("items", "shimmer");
      modalTokenList.appendChild(item);
    }
  }

  removeSkeleton() {
    const { voucherAppliedList, modalTokenList } = this.getSelectors();
    const item = voucherAppliedList?.querySelector(".items.shimmer");
    const item2 = modalTokenList?.querySelector(".items.shimmer");

    if (item) {
      voucherAppliedList.removeChild(item);
    }

    if (item2) {
      modalTokenList.removeChild(item2);
    }
  }

  showModalSkeleton(sum) {
    const { vouchersList } = this.getSelectors();

    if (vouchersList) {
      for (let i = 0; i < sum; i++) {
        const item = document.createElement("div");
        item.classList.add("discount-code_item", "shimmer");
        vouchersList.appendChild(item);
      }
    }
  }

  removeModalSkeleton() {
    const { vouchersList } = this.getSelectors();

    if (vouchersList) {
      const skeletonItems = vouchersList.querySelectorAll(
        ".discount-code_item.shimmer"
      );

      skeletonItems.forEach((item) => {
        vouchersList.removeChild(item);
      });
    }
  }

  showSpinner() {
    const spinner = document.querySelector(".spinner");
    spinner.classList.add("active");
  }

  hideSpinner() {
    const spinner = document.querySelector(".spinner");
    spinner.classList.remove("active");
  }

  async updateCartDisplay() {
    if (this.observer) this.observer.disconnect();
    try {
      this.showSpinner();

      const cartUrl = `${this.root}cart`.replace(/\/+$/, "/");
      const response = await fetch(`${cartUrl}?_=${Date.now()}`).then((res) => res.text());
      const parser = new DOMParser();
      const doc = parser.parseFromString(response, "text/html");

      const selectors = [
        '[data-subtotal]',
        '[data-subtotalfooter]',
        '.cart__subtotal',
        '.cart__total',
        '.voucher-list',
        '.cart-link__count',
        '.discount-box-wrapper',
        '.discount_box',
        '.section-header',
        '.cart-item-main',
        '.cart-empty-has-discount',
        'input[name="discount"]'
      ];

      selectors.forEach(sel => {
        const newEls = doc.querySelectorAll(sel);
        const currentEls = document.querySelectorAll(sel);
        newEls.forEach((el, i) => {
          if (currentEls[i]) {
            if (currentEls[i].className !== el.className) {
              currentEls[i].className = el.className;
            }

            if (currentEls[i].tagName === 'INPUT') {
              currentEls[i].value = el.value;
            } else {
              currentEls[i].innerHTML = el.innerHTML;
            }
          }
        });
      });

      // Re-initialize quantity selectors for the new DOM elements in the table
      const cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        cartPageForm.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.cart-page',
            isCart: true
          });
        });
      }

      {
        const newMain = doc.querySelector('.cart-item-main');
        const currentMain = document.querySelector('.cart-item-main');
        if (!newMain && currentMain) {
          const emptyCartDiv = doc.querySelector('.cart-empty-has-discount');
          if (emptyCartDiv) {
            currentMain.innerHTML = emptyCartDiv.innerHTML;
            currentMain.className = emptyCartDiv.className;
            currentMain.classList.remove('hidden');
          }
        }
      }

      this.removeVoucherApplied();
      this.checkAppliedDiscount();

      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("shopify:cart:updated"));

      return true;
    } catch (error) {
      console.error("Error updating cart display:", error);
      return false;
    } finally {
      this.hideSpinner();
      if (this.observer) {
        const targetNode = document.querySelector(".main-box-total");
        if (targetNode) {
          this.observer.observe(targetNode, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      }
    }
  }

  async addDiscountV2(discounts) {
    try {
      this.showSpinner();

      const cartData = await fetch("/cart.js").then((response) =>
        response.json()
      );

      console.log("Cart: ", cartData);

      const currentDiscounts = cartData.cart_level_discount_applications.map(
        (item) => item.title
      );

      const newDiscounts = discounts.filter(
        (discount) => !currentDiscounts.includes(discount)
      );

      console.log("New discount: ", newDiscounts);

      if (newDiscounts.length > 0) {
        const discountTitles = [...currentDiscounts, ...newDiscounts];
        const response = await this.fetchData(
          this.apiEndPoint.discountUpdate,
          { cartId: cartData.token, discountCodes: discountTitles },
          {}
        );
        console.log("response: ", response);
        const isUpdated = await this.updateCartDisplay();

        if (!isUpdated) {
          return false;
        }
      }

      return true;
    } catch (error) {
      console.error("Error adding discount:", error);
      if (error?.response?.data?.error_fields.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }
    } finally {
      this.hideSpinner();
    }
  }

  async removeDiscountV2(discounts) {
    try {
      this.showSpinner();

      const cartData = await fetch("/cart.js").then((response) =>
        response.json()
      );

      const discountTitles = cartData.cart_level_discount_applications
        .map((item) => item.title)
        .filter((item) => {
          const discountsLowerCase = discounts.map((item2) =>
            item2.toLowerCase()
          );
          return !discountsLowerCase.includes(item.toLowerCase());
        });

      await this.fetchData(
        this.apiEndPoint.discountUpdate,
        {
          cartId: cartData.token,
          discountCodes: discountTitles.length ? discountTitles : [""],
        },
        {}
      );

      await this.updateCartDisplay();
    } catch (error) {
      console.error("Error removing discount:", error);
      if (error?.response?.data?.error_fields.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }
    } finally {
      this.hideSpinner();
      const checkboxes = document.querySelectorAll(".discount-checkbox-item");
      checkboxes.forEach((checkbox) => {
        if (checkbox.classList.contains("disabled")) {
          checkbox.classList.remove("disabled");
          checkbox.parentElement.classList.remove("disabled");
        }
      });
    }
  }

  async addDiscount(discounts, redirect = location.pathname) {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const discountTitles = data.cart_level_discount_applications
          .map((item) => item.title)
          .concat([...discounts]);
        return this.fetchData(
          this.apiEndPoint.discountUpdate,
          { cartId: data.token, discountCodes: discountTitles },
          {}
        ).then(() => {
          location.href = redirect;
        });
      });
  }

  async removeDiscount(discounts, redirect = location.pathname) {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const discountTitles = data.cart_level_discount_applications
          .map((item) => item.title)
          .filter(
            (item) =>
              discounts
                .map((item2) => item2.toLocaleLowerCase())
                .includes(item.toLocaleLowerCase()) === false
          );
        return this.fetchData(
          this.apiEndPoint.discountUpdate,
          {
            cartId: data.token,
            discountCodes: discountTitles.length ? discountTitles : [""],
          },
          {}
        ).then(() => {
          location.href = redirect;
        });
      });
  }

  handleLogout() {
    document.addEventListener("click", async (event) => {
      const logoutLink = event.target.closest('a[href*="/account/logout"]');
      if (logoutLink) {
        event.preventDefault();
        try {
          await this.removeAllDiscounts();
        } catch (e) {
          console.error("Error clearing discounts during logout:", e);
        }
        localStorage.removeItem("isLogin");
        localStorage.removeItem("loyalty_last_verified_at");
        window.location.href = logoutLink.href;
      }
    });
  }

  async removeAllDiscounts() {
    try {
      this.loadingSpinner.show();
      const cartData = await fetch("/cart.js").then((response) =>
        response.json()
      );
      
      await this.fetchData(
        this.apiEndPoint.discountUpdate,
        {
          cartId: cartData.token,
          discountCodes: [""],
        },
        {}
      );
    } catch (error) {
      console.error("Error removing all discounts:", error);
    } finally {
      this.loadingSpinner.hide();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.DiscountCodeManagerInstance = new DiscountCodeManager();
});
